<template>
  <CModal title="Berth Commodity Removing"
          color="danger"
          :centered="true"
          :show="show"
          @update:show="$emit('update:show', false)">

    <div v-if="commodity && berth" class="content">
      <div class="modal-title">
        <h5>Are you sure to remove the following commodity?</h5>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div class="details-row">
        <div class="details-row__title">Commodity Name</div>
        <div class="details-row__value">{{ commodity.commodityName }}</div>
      </div>
      <div class="details-row">
        <div class="details-row__title">Direction</div>
        <div class="details-row__value">{{ commodity.flowDirection }}</div>
      </div>
      <div class="details-row">
        <div class="details-row__title">Commodity Major</div>
        <div class="details-row__value">{{ commodity.commodityMajor }}</div>
      </div>
      <div class="details-row">
        <div class="details-row__title">Berth Name</div>
        <div class="details-row__value">{{ berth.berthName }}</div>
      </div>
    </div>

    <template #footer>
      <CButton @click="$emit('update:show', false)" color="secondary">
        Cancel
      </CButton>
      <CButton @click="handleRemoveBerthCommodity" color="danger">
        Remove
      </CButton>
    </template>

  </CModal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'berth-commodity-remove-modal',

  components: {},

  props: {
    berth: {
      type: Object,
      default: null,
    },

    commodity: {
      type: Object,
      default: null,
    },

    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    ...mapActions(
      'polygons', [
        'removeBerthCommodity',
      ],
    ),

    async handleRemoveBerthCommodity() {
      this.loading = true;
      let result = await this.removeBerthCommodity({
        berthId: this.berth.berthId,
        commodityId: this.commodity.commodityId,
        flowDirection: this.commodity.flowDirection,
      });

      if(result.error) {
        this.errors.push('Unknown error');
      } else {
        this.$emit('updated', result);
      }
      this.loading = false;
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .details-row {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #ad0000;

    &__title {
      min-width: 50px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      direction: rtl;
      text-align: left;
    }
  }

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .fa-cog {
      color: #adadad;
    }
  }
</style>
